import { makeStyles, Typography, alpha, Button } from '@material-ui/core'
import { Home } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';

// Icons
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import FeedbackIcon from '@material-ui/icons/Feedback';
import CreateIcon from '@material-ui/icons/Create';
import HelpIcon from '@material-ui/icons/Help';
//import AccountTreeIcon from '@material-ui/icons/AccountTree';
//import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import { Settings } from '@material-ui/icons';
import InfoIcon from '@material-ui/icons/Info';

import AuthContext from '../../context/authContext';
import { useContext, useState } from 'react';
import { FeedbackBarItem, FeedbackBarMenu } from './FeedbackBarItem';


const useStyles = makeStyles((theme) => ({
    item: {
        display: "flex",
        alignItems: "center",
        height: 36,
        cursor: "pointer",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.black, 0.15),
        },
    },
    feedback: {
        display: "flex",
        alignItems: "center",
        height: 36,
        cursor: "pointer",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.black, 0.15),
        },
        [theme.breakpoints.up("md")]: {
            display: "none"
        },
    },
    icon: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0),
        color: theme.palette.text.main,
        [theme.breakpoints.up("sm")]: {
            fontSize: "lage",
        },
    },
    text: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        color: theme.palette.text.main,
        /*[theme.breakpoints.down("sm")]: {
          display: "none",
        }*/
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    adminLink: {
        //marginTop: 'auto', // Pushes the admin link to the bottom
        marginBottom: theme.spacing(1),
    },
}));

// Bart Intems for Navigation
export const BarItems = ({ setDawerState, setDawerStateDetailView }) => {
    const classes = useStyles();
    // Context
    const contextType = useContext(AuthContext);

    console.log("setDawerStateDetailView:", setDawerStateDetailView);


    // Feedback View
    const [feedbackView, setFeedbackView] = useState(null);

    const handleClickFeedback = (event) => {
        setFeedbackView(event.currentTarget);
    };

    // Reset Drawer
    const handleCloseDrawer = () => {
        //console.log("handleCloseDrawer") 
        if (setDawerState) {
            setDawerState(false)
        }

        if (setDawerStateDetailView) {
            setDawerStateDetailView(false)
        }

    }

    return (
        <>
            {(contextType.permission === "read" || contextType.permission === "write" || contextType.permission === "admin") && (
                <Link to="/" className={classes.link} button onClick={() => handleCloseDrawer()}>
                    <div className={classes.item}>
                        <Home className={classes.icon}></Home>
                        <Typography className={classes.text}>Home</Typography>
                    </div>
                </Link>
            )}



            {(contextType.permission === "write" || contextType.permission === "admin") && (
                <Link to="/edit" className={classes.link} button onClick={() => handleCloseDrawer()}>
                    <div className={classes.item}>
                        <AddCircleOutlineIcon className={classes.icon}></AddCircleOutlineIcon>
                        <Typography className={classes.text}>Create</Typography>
                    </div>
                </Link>
            )}

            {(contextType.permission === "write" || contextType.permission === "admin") && (
                <Link to="/linkAnalysis" className={classes.link} button onClick={() => handleCloseDrawer()}>
                    <div className={classes.item}>
                        <SettingsEthernetIcon className={classes.icon}></SettingsEthernetIcon>
                        <Typography className={classes.text}>Link</Typography>
                    </div>
                </Link>
            )}

            {(contextType.permission === "write" || contextType.permission === "admin") && (
                <Link to="/import" className={classes.link} button onClick={() => handleCloseDrawer()}>
                    <div className={classes.item}>
                        <ImportExportIcon className={classes.icon}></ImportExportIcon>
                        <Typography className={classes.text}>Import</Typography>
                    </div>
                </Link>
            )}



            {contextType.permission !== "superAdmin" && (
                <Divider className={classes.divider} />
            )}
            <div className={classes.feedback} button onClick={handleClickFeedback}>
                <InfoIcon
                    className={classes.icon}
                >
                </InfoIcon>
                <Typography className={classes.text}>Doc & Feedback</Typography>
            </div>
            <FeedbackBarMenu feedbackView={feedbackView} setFeedbackView={setFeedbackView} />

           {/*  <Link to="/documentation" className={classes.link}>
                <div className={classes.item}>
                    <HelpIcon className={classes.icon}></HelpIcon>
                    <Typography className={classes.text}>Documentation</Typography>
                </div>
            </Link> */}

            {contextType.permission === "admin" && (
                <div className={classes.adminLink}>
                    <Link to="/Administration" className={classes.link} button onClick={() => handleCloseDrawer()}>
                        <div className={classes.item}>
                            <Settings className={classes.icon}></Settings>
                            <Typography className={classes.text}>Admin</Typography>
                        </div>
                    </Link>
                </div>
            )}           

            {contextType.permission === "superAdmin" && (
                <div className={classes.adminLink}>
                    <Link to="/SuperAdministration" className={classes.link} button onClick={() => handleCloseDrawer()}>
                        <div className={classes.item}>
                            <Settings className={classes.icon}></Settings>
                            <Typography className={classes.text}>Super Admin</Typography>
                        </div>
                    </Link>
                </div>
            )}
        </>
    )
};